<template lang="pug">
.bet-slip
  .stake-info-wrapper
    template(v-if="match.winlose")
      .bet-status.lose(v-if="parseFloat(match.winlose) < 0")
        span {{ $t("ui.lose") }}
      .bet-status.won(v-else-if="parseFloat(match.winlose) > 0")
        span {{ $t("ui.win") }}
    template(v-else)
      .bet-status(:class="match.bet_status.toLowerCase()")
        span {{ $t("ui." + match.bet_status.toLowerCase()) }}
    .bet-league
      img.icon.mr-1(src="/images/icon-other/lottery-icon.svg?v=12")
      | {{ $t("ui.w4d") }}
    .stake-info
      .betslip-match.others.w4d
        .game-name {{ $t("m.D_" + match.bet_type) }}
        .game-name.font-weight-bold {{ match.number }}
        .game-name
          span.mr-1.text-danger {{ match.comp_name }} - {{ match.num_type }}
          span.mr-1 @
          span.text-info {{ $dayjs(match.match_date).format("MM/DD/YYYY") }}
  .footer-slip.text-left
    .payout-wrapper
      .left
        span.mr-1 {{ $t("ui.stake") }}:
        span.mr-1 {{ $numeral(match.bet_member).format("0,0.[00]") }}
      .right(v-if="match.winlose")
        span.mr-1 {{ parseFloat(match.winlose) < 0 ? $t("ui.lose") : $t("ui.win") }}:
        span(:class="match.winlose != 0 ? match.winlose > 0 ? 'win-amount' : 'lose-amount' : ''") {{ $numeral(match.winlose).format("0,0.00") }}
  .collapse(:id="'statement-child-' + this.uniqueID" :data-parent="'#statement-' + index")
    .bet-details
      .bet-details-row
        .left {{ $t("ui.ref_no") }}: {{ match.ticket_id }} / {{ match.bet_id }}
        .right {{ $t("ui.event") }}: {{ $dayjs(match.bet_time).format("MM/DD/YYYY hh:mm:ss A") }}
      .bet-details-row
        .small(v-if="parseFloat(match.big) > 0")
          span {{ match.num_type == "4D" ? $t("m.D_BIG") : "AE" }}
          span  x {{ $numeral(match.big).format("0,0.00") }}
        .small(v-if="parseFloat(match.small) > 0")
          span {{ $t("m.D_SMALL") }}
          span  x {{ $numeral(match.small).format("0,0.00") }}
        .small(v-if="parseFloat(match.sa) > 0")
          span {{ match.num_type == "4D" ? "SA" : "A" }}
          span  x {{ $numeral(match.sa).format("0,0.00") }}
        .small(v-if="parseFloat(match.sb) > 0")
          span B
          span  x {{ $numeral(match.sb).format("0,0.00") }}
        .small(v-if="parseFloat(match.sc) > 0")
          span C
          span  x {{ $numeral(match.sc).format("0,0.00") }}
        .small(v-if="parseFloat(match.sd) > 0")
          span D
          span  x {{ $numeral(match.sd).format("0,0.00") }}
        .small(v-if="parseFloat(match.se) > 0")
          span E
          span  x {{ $numeral(match.se).format("0,0.00") }}
        .small(v-if="parseFloat(match.aa) > 0")
          span AA
          span  x {{ $numeral(match.aa).format("0,0.00") }}
        .small(v-if="parseFloat(match.abc) > 0")
          span ABC
          span  x {{ $numeral(match.abc).format("0,0.00") }}
  .btn-more-detail(:id="'statement-child-btn-' + this.uniqueID" data-toggle='collapse' :data-target="'#statement-child-' + this.uniqueID" aria-expanded='false' :aria-controls="'statement-child-' + this.uniqueID" @click="showDetail(match)") {{ $t("ui.more_details") }}

</template>

<script>
import config from "@/config";
import naming from "@/library/_name";

export default {
  props: {
    index: {
      type: Number,
      default: 0
    },
    match: {
      type: [Object, Array]
    },
    status: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      loading: false
    }
  },
  computed: {
    uniqueID() {
      if(this.match) {
        return this.match.result_id || this.match.bet_id
      }
    }
  },
  methods: {
    showDetail(match) {
      let id = "#statement-child-btn-" + this.uniqueID
      let isActive = $(id).hasClass('active')
      if($(".btn-more-detail").hasClass('active')) {
        $(".btn-more-detail").removeClass('active').text(this.$t("ui.more_details"))
      }

      if(isActive) {
        $(id).removeClass('active').text(this.$t("ui.more_details"))
      } else {
        $(id).addClass('active').text(this.$t("ui.hide"))
      }
    }
  }
}
</script>